import { useSuspenseQuery, QueryClient } from "@tanstack/react-query"

import { fetchTopLevelCollections } from "@/actions/queries/collection"

export const queryKey = ["top-level-collections"]

export function useTopLevelCollections() {
  return useSuspenseQuery({
    queryKey,
    queryFn: () => fetchTopLevelCollections(),
  })
}

export function prefetchTopLevelCollections(queryClient: QueryClient) {
  return queryClient.prefetchQuery({
    queryKey,
    queryFn: () => fetchTopLevelCollections(),
  })
}
